import React from 'react'

import { VersionSelector } from 'components/VersionSelector'
import config from 'config'
import { useBrandConfig } from 'contexts/BrandConfigContextProvider'
import { createGlobalStyle } from 'styled-components'

import AppContainer from './AppContainer'
import Navbar from './components/Navbar'
import NavbarContainer from './containers/Navbar'
import './App.css'
import LoggedInUser from './containers/Navbar/LoggedInUser/LoggedInUser'
import useUser from './hooks/useUser'
import isLightspeed from './utils/lightspeed'
import { isRouteOneSSO } from './utils/routeone'

const AppBodyBackgroundGlobalStyle = createGlobalStyle`
  body {
    background-color: ${(props) => props.theme.colors.brand.background};
  }
`

function NavbarSection(): JSX.Element | null {
    const { hideNavbarAtLogin } = useBrandConfig()
    const { isLoggedIn } = useUser()

    if (isLightspeed() || isRouteOneSSO()) return null

    if (hideNavbarAtLogin && !isLoggedIn) return null

    return (
        <Navbar>
            <NavbarContainer item={Navbar.Item} dropdown={Navbar.Dropdown} />
            <LoggedInUser />
        </Navbar>
    )
}

function App(): JSX.Element {
    const { isLoggedIn } = useUser()

    return (
        <AppContainer>
            <AppBodyBackgroundGlobalStyle />
            <NavbarSection />
            {/* Gated behind login (PLAT-1073): the pill fetches variant
                metadata (PR #, label, author) - no reason for a logged-out
                visitor to see it. */}
            {config.ENVIRONMENT === 'sandbox' && isLoggedIn && (
                <VersionSelector />
            )}
        </AppContainer>
    )
}

export default App
